export default {
  getCaptcha: {
    method: 'get',
    url: 'captcha'
  },
  login: {
    method: 'post',
    url: 'login'
  },
  logout: {
    method: 'post',
    url: 'logout'
  },
  revisePassword: {
    method: 'post',
    url: 'password'
  },
}
